import { render, staticRenderFns } from "./TransferMenu.vue?vue&type=template&id=7b6989a4&scoped=true"
import script from "./TransferMenu.vue?vue&type=script&lang=js"
export * from "./TransferMenu.vue?vue&type=script&lang=js"
import style0 from "./TransferMenu.vue?vue&type=style&index=0&id=7b6989a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6989a4",
  null
  
)

export default component.exports